import React from 'react';
import { cn } from '@/lib/utils';

function PlayfulContentCard({ icon, iconAlt = '', badge, title, subtitle, meta = [], actionLabel, onAction, actionDisabled = false, onClick, className }) {
  const handleActionClick = e => {
    e.stopPropagation();
    onAction?.();
  };

  return (
    <div
      className={cn('relative flex flex-col rounded-2xl border border-neutral-lightest p-5 shadow-card transition-shadow duration-150 hover:shadow-card-hover', onClick && 'cursor-pointer', className)}
      style={{ background: 'linear-gradient(180deg, #F4FDFF 0%, #F2FCFF 14.65%, #FFFCF1 27.71%)' }}
      onClick={onClick}
    >
      {badge && <span className={cn('absolute right-3 top-3 rounded-[4px] px-1.5 pt-0.5 text-[10px] font-extrabold uppercase tracking-wide text-white shadow-sm', badge.className)}>{badge.text}</span>}

      <img
        src={icon}
        alt={iconAlt}
        className="h-20 w-20 object-contain"
      />

      <h3 className="mb-0 mt-3 line-clamp-3 text-base font-extrabold text-neutral-900">{title}</h3>
      {subtitle && <p className="mb-0 mt-0.5 text-sm text-neutral-dark">{subtitle}</p>}

      <div className="mt-auto flex flex-col gap-3 pt-2">
        {meta.length > 0 && (
          <div className="flex flex-wrap items-center justify-between gap-x-4 gap-y-1 text-xs font-semibold text-neutral-dark">
            {meta.map((item, index) => (
              <span
                key={index}
                className="flex items-center gap-1.5"
              >
                {item.icon && <item.icon className={cn('h-3.5 w-3.5', !actionDisabled && 'text-mission')} />}
                {item.text}
              </span>
            ))}
          </div>
        )}

        {actionLabel && (
          <button
            type="button"
            onClick={handleActionClick}
            disabled={actionDisabled}
            className={cn('w-full rounded-full py-2.5 text-sm font-extrabold text-white transition-transform duration-100 active:translate-y-px', actionDisabled && 'cursor-not-allowed bg-[#FFECD8]')}
            style={actionDisabled ? undefined : { background: 'var(--gradient-btn-continue)', boxShadow: '0 3px 0 var(--color-mission-dark)' }}
          >
            {actionLabel}
          </button>
        )}
      </div>
    </div>
  );
}

export { PlayfulContentCard };
